export default {
  API_SCHEME: "https://",
  API_URL: "fct3.hobbitgenie.com",
  API_CONTEXT: "/hobbitgenie-api/api/v1",
  SHOW_NEW_TABLE: true
};
